import { useRequest } from 'features/request/useRequest';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { gqlWorkOrderObjects } from '../workOrderQueries';

export const useWorkOrderObjects = (workOrderId: number, withEffect = true) => {
    const variables = useMemo(() => ({ workOrderId }), [workOrderId]);
    const dispatch = useDispatch();

    const [data, status, error, makeRequest] = useRequest({
        requestId: 'workOrderObjects',
        query: gqlWorkOrderObjects,
        variables,
        withEffect,
    });

    const refreshWorkOrderObjects = useCallback(() => {
        dispatch(makeRequest(variables));
    }, [dispatch, makeRequest, variables]);

    // т.к только для одного места в НЗ (фильтр объектов) нужно брать данные из contractObject - патчим данные
    const patchedObjectForWorkOrderFilter = useMemo(
        () =>
            data?.uerWorkOrderObjects?.map((object, index, initialArr) => {
                const realRootId = initialArr.find(
                    (initObj) => initObj.contractObject?.id === object.contractObject?.rootObjectId,
                )?.id;
                const realParentId =
                    initialArr.find((initObj) => initObj.contractObject?.id === object.contractObject?.parentId)?.id ??
                    null;

                return {
                    ...object,
                    parentId: realParentId,
                    rootObjectId: realRootId,
                };
            }),
        [data?.uerWorkOrderObjects],
    );

    return {
        workOrderObjects: data?.uerWorkOrderObjects,
        status,
        error,
        refreshWorkOrderObjects,
        patchedObjectForWorkOrderFilter,
    };
};
